module.exports = __webpack_public_path__ + "static/media/topicals_stock80.d63d0fdc.jpg";